/** 
 * sequence module
 * @module sequence:tes
 */

 /**
 * @constructor
 * @alias module:sequence:tes
 */
window['sequence:tes'] = (function(document, $) {

    var sequences = {};

    function queue(name, callback) {
        var sequence = sequences[name];
        if (sequence) {
            sequence.push(callback)
        }
        else {
            sequences[name] = [];
            sequences[name].push(callback)
        }
    }

    function dequeue(name) {
        var sequence = sequences[name];
        var callback;
        if (sequence) {
            callback = sequence.shift();
            if (callback) {
                callback();
            }
        }
    }

    function clear(name) {
        sequences[name] = null;
    }

    return {
        /** queue in sequence */
        queue : queue,
        /** dequeue in sequence */
        dequeue : dequeue,
        /** clear sequence */
        clear : clear
    }

}(document, jQuery));